const GROESSE = { klein: "size-(--marke-klein) t-caption-1", mittel: "size-(--marke) t-footnote", gross: "size-(--touch) t-headline" };

/** Personen-Marke (Handoff personBadge): Initiale in einem Quadrat mit Radius 8, gedaempfte
 *  Personenfarbe. Traegt den Namen als `aria-label` und `title`; nur zeigen, wenn es mindestens zwei
 *  Personen gibt (Plan 6.6). */
export function PersonMarke(props: { name: string; farbe: string; groesse?: keyof typeof GROESSE; dekorativ?: boolean }) {
  const initiale = props.name.trim().charAt(0).toUpperCase() || "?";
  return (
    <span
      role={props.dekorativ ? undefined : "img"}
      aria-label={props.dekorativ ? undefined : props.name}
      aria-hidden={props.dekorativ || undefined}
      title={props.name}
      className={`inline-grid shrink-0 place-items-center rounded-avatar font-bold ${GROESSE[props.groesse ?? "mittel"]} ${props.farbe}`}
    >
      {initiale}
    </span>
  );
}
